export default __webpack_public_path__ + "static/media/menu_upload_beat.c9e6b9da.svg";